import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import React, { CSSProperties, FC } from 'react';
import { getPaletteBasename } from '../../../utils';
import { useThemeColorPalette } from '../../../hooks/use-theme-color-palette';
import { Icon } from '../../icon';
import { ThemeColorsPaletteTonalities, ThemeColorsValues } from '../../../theme';
import classes from './confirmation-card-icon.module.scss';

export type ConfirmationCardIconProps = {
  /**
   * Custom string
   */
  icon: FontAwesomeIconProps['icon'];

  /**
   * Custom color for icon. Background will bi automatically loaded from the palettes ultra light color
   */
  color?: ThemeColorsPaletteTonalities;
};

export const ConfirmationCardIcon: FC<ConfirmationCardIconProps> = ({
  color = 'grey.dark',
  icon,
}) => {
  const paletteName = getPaletteBasename(color as ThemeColorsValues);
  const palette = useThemeColorPalette(paletteName);

  return (
    <div
      className={classes.root}
      style={
        {
          '--confirmation-card-icon--background': palette?.['ultra-light'],
        } as CSSProperties
      }
    >
      <Icon color={color as ThemeColorsValues} icon={icon} className={classes.icon} />
    </div>
  );
};
